import GnbActionTypes from './gnb.types';

export const handleMobileGnbMenu = () => ({
  type: GnbActionTypes.HANDLE_MOBILE_GNB_MENU,
});
